<template lang="pug">
  div(id="app" :class="{animating}")
    branding
    history(:items="history" :selected="selected" @waypoint="setWaypoint")
    navigation(:items="navigation" :selected="selected" @selection="select" @animating="animate")
    wheel(:selected="selected" :current="current" :animating="animating")
</template>

<script>
import content from './assets/json/content.json'
import branding from './components/branding'
import history from './components/history'
import navigation from './components/navigation'
import wheel from './components/wheel'
export default {
  name: 'App',
  data () {
    return {
      history: content,
      selected: 1,
      animating: false,
      timeout: null,
      current: 1
    }
  },
  computed: {
    navigation () {
      return this.history.map((item, index) => {
        return {
          id: index + 1,
          year: item.year
        }
      })
    }
  },
  methods: {
    select (item) {
      this.selected = item.id
    },
    animate (duration) {
      console.log(duration)
      this.animating = true
      if (!this.timeout) {
        this.timeout = window.setTimeout(this.stop, duration)
      }
    },
    stop () {
      console.log('stopping')
      this.timeout = false
      this.animating = false
    },
    setWaypoint (id) {
      this.current = id
    }
  },
  components: {
    branding,
    history,
    navigation,
    wheel
  }
}
</script>

<style lang="stylus">
  $yellow = #FFDD00

  body
    width: 100%
    margin: 0
    box-sizing: border-box;
    & *
      box-sizing: inherit;

  #app
    height: 100vh
    width: 100%
    // position: relative;
    background: $yellow
    // background: grey
    font-family: 'Arial', sans-serif;
    font-family: 'Coda', cursive;
    &:before
      content: ''
      position: absolute;
      bottom: 0
      left: 0
      right: 0
      height: 15em
      background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);
      opacity: 0.6
      z-index: 2
</style>



// WEBPACK FOOTER //
// src/App.vue